import './applied_grouped_elements_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

FILTERS = Common.Dashboard.Filters

class Common.Dashboard.Filters.AppliedPrimaryGroupedElementsView extends FILTERS.AppliedGroupedElementsView

  initialize: ({filter, isReadOnly}) ->
    super({filter, titleClassName: '', isReadOnly})

  _displayTitle: ->
    ''

  _displayValues: ->
    @_mapValues(@_values())

  _values: ->
    type = @filter.getValues()?.included?.type
    return ['All Intelligent Labels'] if type == 'all'
    return ['No Intelligent Labels'] if type == 'none'
    @filter.getValues()?.included?.primary?.values || []
